// utils/toast.ts
import { toast } from 'vue-sonner'

/**
 * Get toast styles based on type
 * @param type - The type of notification
 */
const getToastOptions = (type: 'success' | 'error' | 'warning') => {
  const baseOptions = {
    duration: 7000,
    position: 'top-right' as const,
    style: {
      color: 'white',
      borderRadius: '8px',
    }
  }

  const backgrounds = {
    success: '#03C03C',  // Green
    error: '#EF4444',    // Red
    warning: '#F59E0B',  // Amber/Orange
  }

  return {
    ...baseOptions,
    style: {
      ...baseOptions.style,
      background: backgrounds[type],
    }
  }
}

/**
 * Display a notification message using Sonner toast
 * @param message - The message to display
 * @param type - The type of notification: 'success', 'error', or 'warning'
 */
export function setNotificationToast(
  message: string,
  type: 'success' | 'error' | 'warning' = 'success'
) {
  const options = getToastOptions(type)

  switch (type) {
    case 'success':
      toast.success(message, options)
      break
    case 'error':
      toast.error(message, options)
      break
    case 'warning':
      toast.warning(message, options)
      break
    default:
      toast(message, options)
  }
}

// Optional: Export individual functions for better tree-shaking
export const showSuccess = (message: string) => 
  setNotificationToast(message, 'success')

export const showError = (message: string) => 
  setNotificationToast(message, 'error')

export const showWarning = (message: string) => 
  setNotificationToast(message, 'warning')